/*


*/
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import Paginate from 'vuejs-paginate-next'
import { Vue3Mq } from 'vue3-mq'
import installElement from './plugins/element'

const app = createApp(App)

app.use(router)

app.config.globalProperties.axios = axios

app.use(Vue3Mq, {
  breakpoints: { sp: 0, pc: 960 },
  defaultBreakpoint: 'sp',
  global: true
})

installElement(app)

app.component('paginate', Paginate)

app.mount('#app')
